module.exports = __webpack_public_path__ + "e6b0a4e616220dd234cad388e8f77820.png";